import React from "react";
import { useSelector } from "react-redux";
import { selectUnregulatedPower, selectUnregulatedBreakers } from "../../../redux/selectors";

const PrintUnregulated = () => {
  const unregulatedPowerDetails = useSelector(selectUnregulatedPower);
  const unregulatedBreakersDetails = useSelector(selectUnregulatedBreakers);

  const hasUnregulated = unregulatedPowerDetails?.some(detail => detail.HasUnregulated);

  if (!hasUnregulated || !unregulatedPowerDetails || unregulatedPowerDetails.length === 0) {
    return null;
  }

  const isZoneEmpty = (detail) => {
    return (
      !detail.SupplyType &&
      !detail.Quantity &&
      !detail.Comments
    );
  };

  const renderDetails = (details) => {
    if (!details || !Array.isArray(details) || details.length === 0) {
      return null;
    }

    const groupedDetails = details.reduce((acc, detail) => {
      if (!acc[detail.Zone]) {
        acc[detail.Zone] = [];
      }
      acc[detail.Zone].push(detail);
      return acc;
    }, {});

    return (
      <div>
        {Object.keys(groupedDetails).map((zone, index) => {
          const zoneDetails = groupedDetails[zone];
          const breakers = unregulatedBreakersDetails.filter(breaker => String(breaker.Zone) === zone);

          if (zoneDetails.every(isZoneEmpty) && breakers.length === 0) {
            return null;
          }

          return (
            <div className="section" key={index}>
              <h3 className="print-zone-label">Zone: {zone}</h3>
              <table className="table table-bordered full-width">
                <tbody>
                  {zoneDetails.map((detail, idx) => {
                    if (isZoneEmpty(detail)) {
                      return null;
                    }
                    return (
                      <tr key={idx}>
                        <td className="col-md-6">
                          <table>
                            <tbody>
                              <tr><td><strong>Supply Type: </strong>{detail.SupplyType}</td></tr>
                              <tr><td><strong>Quantity: </strong>{detail.Quantity}</td></tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {breakers.length > 0 && (
                <>
                  <h4 className="text-center">Unregulated Breakers</h4>
                  <table className="table table-bordered full-width">
                    <thead>
                      <tr>
                        <th>Quantity</th>
                        <th>Amps</th>
                        <th>Voltage</th>
                      </tr>
                    </thead>
                    <tbody>
                      {breakers.map((breaker, idx) => (
                        <tr key={idx}>
                          <td>{breaker.Quantity}</td>
                          <td>{breaker.Amps}</td>
                          <td>{breaker.Voltage}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )}
              <p><strong>Comments:</strong><br />{zoneDetails[0]?.Comments}</p>
              <br className="clearfix" />
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div>
      {unregulatedPowerDetails.some(detail => !isZoneEmpty(detail)) && (
        <>
          <h2 className="print-section-header">Unregulated Power Summary</h2>
          {renderDetails(unregulatedPowerDetails)}
        </>
      )}
    </div>
  );
};

export default PrintUnregulated;
